module.exports = __webpack_public_path__ + "img/2.29ca874.jpg";